export default __webpack_public_path__ + "static/media/water-budget-active.060ad550.svg";